import { AfterViewChecked, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { Theme } from '../../layouts/ats-service/service-models/theme';

@Component({
  selector: 'app-job-closed',
  templateUrl: './job-closed.component.html',
  styleUrls: ['./job-closed.component.scss']
})
export class JobClosedComponent implements OnInit, OnDestroy, AfterViewChecked {
  private subscription = new Subscription();

  identifier: string;
  theme: Theme;

  constructor(private route: ActivatedRoute) { }

  ngAfterViewChecked(): void {
    this.theme.apply();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.subscription.add(this.route.parent.params.subscribe((params: Params) => {
      this.identifier = params['identifier'];
    }));

    this.subscription.add(this.route.data
      .subscribe((data: { model: Theme }) => {
        this.theme = Object.assign(new Theme(), data.model);
      })
    );
  }
}
